export const SCHEDULE_SHOW_ADD_EVENT_MODAL = 'SCHEDULE_SHOW_ADD_EVENT_MODAL';
export const SCHEDULE_SHOW_EDIT_EVENT_MODAL = 'SCHEDULE_SHOW_EDIT_EVENT_MODAL';
export const SCHEDULE_SHOW_DELETE_EVENT = 'SCHEDULE_SHOW_DELETE_EVENT';
export const SCHEDULE_SET_DELETE_MULTIPLE = 'SCHEDULE_SET_DELETE_MULTIPLE';
